module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.713/img/screenshot-og.png"